export { default as default } from './AdminPageWrapper';
